import globalAxios from "../../../util/Api";
import {
  GET_LEAD_LISTS,
  GET_PROJECT_LISTS,
  GET_USER_LISTS,
  CREATE_LEAD_PLAN_OFFER,
  UPDATE_LEAD_PLAN_OFFER,
  DELETE_LEAD_PLAN_OFFER,
  CREATE_LEAD_PLAN,
  UPDATE_LEAD_PLAN,
  DELETE_LEAD_PLAN,
  CREATE_LEAD_OFFER,
  UPDATE_LEAD_OFFER,
  DELETE_LEAD_OFFER,
  START_LOADING,
  STOP_LOADING,
  ERROR
} from "./types";
import { LogoutAction } from "../../../actions";

export const GetLeadLists = (year, branch_id, classification_id, theme_id, group_id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/leads`, {
      params: {
        year: year,
        'q[branch_id_eq]': branch_id,
        'q[classification_id_eq]': classification_id,
        'q[theme_id_eq]': theme_id,
        group_by: group_id,
      }
    }).then(resultSet => {
      if (resultSet) {
        dispatch({ type: STOP_LOADING })
        dispatch({ type: GET_LEAD_LISTS, payload: resultSet.data })
      }
    }).catch(err => {
      dispatch({ type: STOP_LOADING })
      if (err.response)
        if (err.response.status === 401) {
          dispatch(LogoutAction())
        }
    })
  }
}

export const GetProjectsData = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/projects_leads`)
      .then(resultSet => {
        if (resultSet) {
          dispatch({ type: GET_PROJECT_LISTS, payload: resultSet.data.projects })
        }
      })
  }
}

export const GetUsersData = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/users`, {
      params: {
        lead: 'lead'
      }
    }).then(resultSet => {
      if (resultSet) {
        dispatch({ type: GET_USER_LISTS, payload: resultSet.data.users })
      }
    })
  }
}

export const CreateLeadPlanOffer = (leadProjectNumber, leadCustomerName, leadProjectName,
  leadBranchNumber, leadThemeNumber, leadClassificationNumber,
  leadComment, leadPartnerNumberOne, leadPercentNumberOne,
  leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree,
  leadPercentNumberThree, lead_plans, lead_offers, year, branch_id, classification_id, theme_id, group_id) => {

  let bodyFormData = new FormData();
  bodyFormData.append('lead[branch_id]', leadBranchNumber);
  bodyFormData.append('lead[classification_id]', leadClassificationNumber);
  bodyFormData.append('lead[project_id]', leadProjectNumber);
  bodyFormData.append('lead[theme_id]', leadThemeNumber);
  bodyFormData.append('lead[projectname]', leadProjectName);
  bodyFormData.append('lead[comment]', leadComment);
  bodyFormData.append('lead[customername]', leadCustomerName);
  bodyFormData.append('lead[lead1id]', leadPartnerNumberOne);
  bodyFormData.append('lead[lead1percent]', leadPercentNumberOne);
  bodyFormData.append('lead[lead2id]', leadPartnerNumberTwo);
  bodyFormData.append('lead[lead2percent]', leadPercentNumberTwo);
  bodyFormData.append('lead[lead3id]', leadPartnerNumberThree);
  bodyFormData.append('lead[lead3percent]', leadPercentNumberThree);

  lead_plans.map((item, index) => {
    bodyFormData.append(`lead[lead_plans_attributes][${index}][addcosts]`, item.addcosts);
    bodyFormData.append(`lead[lead_plans_attributes][${index}][fee]`, item.fee);
    bodyFormData.append(`lead[lead_plans_attributes][${index}][plan2]`, item.plan2);
    bodyFormData.append(`lead[lead_plans_attributes][${index}][plan3]`, item.plan3);
    bodyFormData.append(`lead[lead_plans_attributes][${index}][probability]`, item.probability);
    bodyFormData.append(`lead[lead_plans_attributes][${index}][year]`, item.year);
  })

  lead_offers.map((item, index) => {
    bodyFormData.append(`lead[offers_attributes][${index}][addcosts]`, item.addcosts);
    bodyFormData.append(`lead[offers_attributes][${index}][addcostsinfo]`, item.addcostsinfo);
    bodyFormData.append(`lead[offers_attributes][${index}][days]`, item.days);
    bodyFormData.append(`lead[offers_attributes][${index}][decision]`, item.decision);
    bodyFormData.append(`lead[offers_attributes][${index}][decisiondate]`, item.decisiondate);
    bodyFormData.append(`lead[offers_attributes][${index}][fee]`, item.fee);
    bodyFormData.append(`lead[offers_attributes][${index}][mail]`, item.mail);
    bodyFormData.append(`lead[offers_attributes][${index}][offerdate]`, item.offerdate);
    bodyFormData.append(`lead[offers_attributes][${index}][paper]`, item.paper);
  })

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/leads`, bodyFormData)
      .then(resultSet => {
        if (resultSet) {
          dispatch({type: CREATE_LEAD_PLAN_OFFER, payload: resultSet})
          dispatch(GetLeadLists(year, branch_id, classification_id, theme_id, group_id))
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          console.log(err);
      })
  }
}

export const UpdateLeadPlanOffer = (lead_id, leadProjectNumber, leadCustomerName, leadProjectName,
  leadBranchNumber, leadThemeNumber, leadClassificationNumber,
  leadComment, leadPartnerNumberOne, leadPercentNumberOne,
  leadPartnerNumberTwo, leadPercentNumberTwo, leadPartnerNumberThree,
  leadPercentNumberThree, year, branch_id, classification_id, theme_id, group_id) => {

  let bodyFormData = new FormData();
  bodyFormData.append('lead[branch_id]', leadBranchNumber);
  bodyFormData.append('lead[classification_id]', leadClassificationNumber);
  bodyFormData.append('lead[project_id]', leadProjectNumber === '-1' || leadProjectNumber === null ? '' : leadProjectNumber);
  bodyFormData.append('lead[theme_id]', leadThemeNumber);
  bodyFormData.append('lead[projectname]', leadProjectName);
  bodyFormData.append('lead[comment]', leadComment);
  bodyFormData.append('lead[customername]', leadCustomerName);
  bodyFormData.append('lead[lead1id]', leadPartnerNumberOne);
  bodyFormData.append('lead[lead1percent]', leadPercentNumberOne);
  bodyFormData.append('lead[lead2id]', leadPartnerNumberTwo === '-1' ? '' : leadPartnerNumberTwo);
  bodyFormData.append('lead[lead2percent]', leadPercentNumberTwo);
  bodyFormData.append('lead[lead3id]', leadPartnerNumberThree === '-1' ? '' : leadPartnerNumberThree);
  bodyFormData.append('lead[lead3percent]', leadPercentNumberThree);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/leads/${lead_id}`, bodyFormData)
      .then(resultSet => {
        if (resultSet) {
          dispatch({type: UPDATE_LEAD_PLAN_OFFER, payload: resultSet})
          dispatch(GetLeadLists(year, branch_id, classification_id, theme_id, group_id))
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data })
      })
  }
}

export const DeleteLeadPlanOffer = (lead_id, year, branch_id, classification_id, theme_id, group_id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/leads/${lead_id}`)
      .then(resultSet => {
        if (resultSet) {
          dispatch({type: DELETE_LEAD_PLAN_OFFER, payload: resultSet})
          dispatch(GetLeadLists(year, branch_id, classification_id, theme_id, group_id))
          dispatch({ type: STOP_LOADING })
        }
      })
  }
}

export const CreateLeadPlan = (lead_id, year, probability, plan2, plan3) => {
  let bodyFormData = new FormData();
  bodyFormData.append('lead[lead_plans_attributes][0][plan2]', plan2);
  bodyFormData.append('lead[lead_plans_attributes][0][plan3]', plan3);
  bodyFormData.append('lead[lead_plans_attributes][0][probability]', probability);
  bodyFormData.append('lead[lead_plans_attributes][0][year]', year);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/leads/${lead_id}`, bodyFormData)
      .then(resultSet => {
        if (resultSet) {
          dispatch({ type: CREATE_LEAD_PLAN, payload: resultSet.data.lead.lead_plans })
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data })
      })
  }
}

export const UpdateLeadPlan = (lead_id, plan_id, year, probability, plan2, plan3) => {
  let bodyFormData = new FormData();
  bodyFormData.append('lead[lead_plans_attributes][0][id]', plan_id);
  bodyFormData.append('lead[lead_plans_attributes][0][plan2]', plan2);
  bodyFormData.append('lead[lead_plans_attributes][0][plan3]', plan3);
  bodyFormData.append('lead[lead_plans_attributes][0][probability]', probability);
  bodyFormData.append('lead[lead_plans_attributes][0][year]', year);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/leads/${lead_id}`, bodyFormData)
      .then(resultSet => {
        if (resultSet) {
          dispatch({ type: UPDATE_LEAD_PLAN, payload: resultSet.data.lead.lead_plans })
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          console.log(err);
      })
  }
}

export const DeleteLeadPlan = (lead_id, lead_plan_id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/leads/${lead_id}/lead_plans/${lead_plan_id}`)
      .then(resultSet => {
        if (resultSet) {
          dispatch({ type: DELETE_LEAD_PLAN, payload: resultSet.data.lead.lead_plans })
          dispatch({ type: STOP_LOADING })
        }
      })
  }
}

export const CreateLeadOffer = (lead_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision) => {
  let bodyFormData = new FormData();
  bodyFormData.append('lead[offers_attributes][0][offerdate]', offerdate);
  bodyFormData.append('lead[offers_attributes][0][paper]', paper);
  bodyFormData.append('lead[offers_attributes][0][mail]', mail);
  bodyFormData.append('lead[offers_attributes][0][fee]', fee);
  bodyFormData.append('lead[offers_attributes][0][days]', days);
  bodyFormData.append('lead[offers_attributes][0][addcosts]', addcosts);
  bodyFormData.append('lead[offers_attributes][0][addcostsinfo]', addcostsinfo);
  bodyFormData.append('lead[offers_attributes][0][decisiondate]', decisiondate);
  bodyFormData.append('lead[offers_attributes][0][decision]', decision);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/leads/${lead_id}`, bodyFormData)
      .then(resultSet => {
        if (resultSet) {
          dispatch({ type: CREATE_LEAD_OFFER, payload: resultSet.data.lead.offers })
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          console.log(err);
      })
  }
}

export const UpdateLeadOffer = (lead_id, offer_id, offerdate, paper, mail, fee, days, addcosts, addcostsinfo, decisiondate, decision) => {
  let bodyFormData = new FormData();
  bodyFormData.append('lead[offers_attributes][0][id]', offer_id);
  bodyFormData.append('lead[offers_attributes][0][offerdate]', offerdate);
  bodyFormData.append('lead[offers_attributes][0][paper]', paper);
  bodyFormData.append('lead[offers_attributes][0][mail]', mail);
  bodyFormData.append('lead[offers_attributes][0][fee]', fee);
  bodyFormData.append('lead[offers_attributes][0][days]', days);
  bodyFormData.append('lead[offers_attributes][0][addcosts]', addcosts);
  bodyFormData.append('lead[offers_attributes][0][addcostsinfo]', addcostsinfo);
  bodyFormData.append('lead[offers_attributes][0][decisiondate]', decisiondate);
  bodyFormData.append('lead[offers_attributes][0][decision]', decision);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/leads/${lead_id}`, bodyFormData)
      .then(resultSet => {
        if (resultSet) {
          dispatch({ type: UPDATE_LEAD_OFFER, payload: resultSet.data.lead.offers })
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          console.log(err);
      })
  }
}

export const DeleteLeadOffer = (lead_id, lead_offer_id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/leads/${lead_id}/offers/${lead_offer_id}`)
      .then(resultSet => {
        if (resultSet) {
          dispatch({ type: DELETE_LEAD_OFFER, payload: resultSet.data.lead.offers })
          dispatch({ type: STOP_LOADING })
        }
      })
  }
}